import { emptySplitApi as api } from "./emptyApi"

export interface ApiKeyDto {
  id: string
  userId: string
  label: string | null
  readOnly: boolean
  createdAt: string
  lastUsedAt: string | null
  revokedAt: string | null
}

export interface CreateApiKeyResponseDto {
  token: string
  keyInfo: ApiKeyDto
}

export interface CreateApiKeyDto {
  label?: string
  readOnly?: boolean
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    cliControllerListApiKeys: build.query<ApiKeyDto[], void>({
      query: () => ({ url: `/cli/api-keys` }),
      providesTags: ["ApiKeys"],
    }),
    cliControllerCreateApiKey: build.mutation<
      CreateApiKeyResponseDto,
      CreateApiKeyDto
    >({
      query: dto => ({
        url: `/cli/api-keys`,
        method: "POST",
        body: dto,
      }),
      invalidatesTags: ["ApiKeys"],
    }),
    cliControllerRevokeApiKey: build.mutation<ApiKeyDto, string>({
      query: id => ({
        url: `/cli/api-keys/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ApiKeys"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

export const {
  useCliControllerListApiKeysQuery,
  useCliControllerCreateApiKeyMutation,
  useCliControllerRevokeApiKeyMutation,
} = injectedRtkApi
